import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../../lib/api';
import WorkspaceWorkPanel from '../../../components/WorkspaceWorkPanel';
import type { WidgetRenderProps } from '../../../widgets/types';

interface ProjectGet {
  ok?: boolean;
  project?: { slug?: string };
  gitlab_path?: string | null;
  workspace_instance?: string | null;
}

/** Widget obal — stejný panel jako ve workspace, slug z URL projektu. */
export function CodableWorkspaceWorkWidget(_props: WidgetRenderProps) {
  const { t } = useTranslation();
  const { id = '' } = useParams<{ id: string }>();
  const q = useQuery({
    queryKey: ['codable-project', id],
    queryFn: () => api.mcp<ProjectGet>('codable.project_get', { id }, { silent: true }),
    enabled: !!id,
    staleTime: 20_000,
  });
  const slug = q.data?.project?.slug;
  if (!slug) {
    return (
      <div className='px-3 py-4 text-xs text-gray-500'>
        {t('workspaceWork.widgetNeedProject', 'Otevři Codable projekt — panel patří k instanci i k projektu.')}
      </div>
    );
  }
  return (
    <WorkspaceWorkPanel
      scope={{
        kind: 'project',
        slug,
        gitlabPath: q.data?.gitlab_path ?? null,
        instance: q.data?.workspace_instance ?? null,
      }}
    />
  );
}
